<template>
  <div class="partners" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule" />
    <div class="content">
      <div class="line-item">
        <div class="head-photo">
          <img src="https://summit-img.geekpark.net/ifx/pc/%E4%B8%BB%E5%8A%9E%E6%96%B9.svg" alt />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[0].partners"
            :key="item.logo.url||'index0' + index"
          >
            <img :src="item.logo.url" />
          </div>
          <div class="item"></div>
          <div class="item title">
            <img
              src="https://summit-img.geekpark.net/ifx/pc/%E8%81%94%E5%90%88%E5%87%BA%E5%93%81%E6%96%B9.svg"
              alt
            />
          </div>
          <div
            class="item"
            v-for="(item,index) in partner_categories[1].partners"
            :key="item.logo.url||'index1' + index"
          >
            <img :src="item.logo.url" />
          </div>
          <div class="item"></div>
          <div class="item title">
            <img
              src="https://summit-img.geekpark.net/ifx/pc/%E8%81%94%E5%90%88%E4%B8%BB%E5%8A%9E%E6%96%B9.svg"
              alt
            />
          </div>
          <div
            class="item"
            v-for="(item,index) in partner_categories[2].partners"
            :key="item.logo.url||'index2' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E5%93%81%E7%89%8C%E8%81%94%E5%90%88%E6%9C%BA%E6%9E%84.svg"
            alt
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[3].partners"
            :key="item.logo.url||'index3' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E5%88%9B%E6%96%B0%E5%90%88%E4%BD%9C%E6%9C%BA%E6%9E%84.svg"
            alt
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[4].partners"
            :key="item.logo.url||'index4' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E6%8A%95%E8%B5%84%E6%9C%BA%E6%9E%84%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.svg"
            style="height: 3vh"
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[5].partners"
            :key="item.logo.url||'index5' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E5%AA%92%E4%BD%93%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.svg"
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[6].partners"
            :key="item.logo.url||'index6' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E8%A7%86%E9%A2%91%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.svg"
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[7].partners"
            :key="item.logo.url||'index7' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E5%93%81%E7%89%8C%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.svg"
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[8].partners"
            :key="item.logo.url||'index8' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E4%BA%92%E5%8A%A8%E5%90%88%E4%BD%9C%E6%9C%BA%E6%9E%84.svg"
            alt
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[9].partners"
            :key="item.logo.url||'index9' + index"
          >
            <img :src="item.logo.url" />
          </div>
          <div class="item title">
            <img
              src="https://summit-img.geekpark.net/ifx/pc/%E6%95%99%E8%82%B2%E5%90%88%E4%BD%9C%E5%B9%B3%E5%8F%B0.svg"
              alt
            />
          </div>
          <div
            class="item"
            v-for="(item,index) in partner_categories[10].partners"
            :key="item.logo.url||'index10' + index"
          >
            <img :src="item.logo.url" />
          </div>
          <div class="item title">
            <img
              src="https://summit-img.geekpark.net/ifx/pc/%E6%B7%B1%E5%BA%A6%E5%86%85%E5%AE%B9%E5%90%88%E4%BD%9C%E5%B9%B3%E5%8F%B0.svg"
              style="height: 3vh"
            />
          </div>
          <div
            class="item"
            v-for="(item,index) in partner_categories[11].partners"
            :key="item.logo.url||'index11' + index"
          >
            <img :src="item.logo.url" />
          </div>
          <div class="item title">
            <img
              src="https://summit-img.geekpark.net/ifx/pc/%E9%A6%96%E5%B8%AD%E5%86%85%E5%AE%B9%E7%94%9F%E6%80%81%E5%B9%B3%E5%8F%B0.svg"
              style="height: 3vh"
            />
          </div>
          <div
            class="item"
            v-for="(item,index) in partner_categories[12].partners"
            :key="item.logo.url||'index12' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
      <div class="line-item">
        <div class="head-photo">
          <img
            src="https://summit-img.geekpark.net/ifx/pc/%E9%A6%96%E5%B8%AD%E5%88%9B%E6%84%8F%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.svg"
            style="height: 3vh"
          />
        </div>
        <div class="line">
          <div
            class="item"
            v-for="(item,index) in partner_categories[13].partners"
            :key="item.logo.url||'index13' + index"
          >
            <img :src="item.logo.url" />
          </div>
          <div class="item title">
            官方指定
            <br />图片直播平台
          </div>
          <div
            class="item"
            v-for="(item,index) in partner_categories[14].partners"
            :key="item.logo.url||'index14' + index"
          >
            <img :src="item.logo.url" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleNav from "./ModuleNav";
import { mapState } from "vuex";

export default {
  name: "Partners",
  components: { ModuleNav },
  computed: {
    ...mapState({
      nav: state => state.partners.nav,
      partner_categories: state => state.global.activity.partner_categories
    })
  },
  data() {
    return {
      isInModule: false
    };
  },
  methods: {
    mouseEnter() {
      this.isInModule = true;
    },
    mouseLeave() {
      this.isInModule = false;
    }
  }
};
</script>

<style scoped lang="less">
.partners {
  display: flex;
  height: 100vh;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 17vh 0 5vh;
  width: 150vh;
  height: 86vh;
  margin-top: 7vh;

  > img {
    height: 100%;
  }

  .line-item {
    display: flex;
    justify-content: left;
    align-items: stretch;
    height: 6vh;

    &:nth-of-type(2),
    &:nth-of-type(3),
    &:nth-of-type(7) {
      height: 12vh;

      .head-photo {
        align-items: flex-start;
        margin-top: 2vh;
      }
    }

    &:nth-of-type(5) {
      height: 24vh;

      .head-photo {
        align-items: flex-start;
        margin-top: 1.2vh;
      }
    }
  }
}

.head-photo {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 15vh;
  padding-right: 2vh;

  img {
    height: 1.5vh;
  }
}

.line {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  width: 132vh;

  .item {
    box-sizing: border-box;
    width: 10vh;

    img {
      width: 110%;
      height: 110%;
      margin-top: -5%;
      margin-left: -5%;
    }
  }

  .item.title {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
    font-size: 1.37vh;

    img {
      height: 1.4vh;
    }
  }
}
</style>
